@if (showWrapper) {
  <div
    class="encounter-skeleton-wrapper bg-white border rounded-lg w-full max-h-full overflow-hidden"
    style="border-color: var(--color-outline-variant)"
    data-testid="encounter-skeleton">
    <div class="min-w-[900px]">
      @if (showHeader) {
        <div class="encounter-skeleton-header">
          @for (_ of skeletonCells; track $index) {
            <div class="encounter-skeleton-cell">
              <app-skeleton width="60%" height="0.875rem"></app-skeleton>
            </div>
          }
        </div>
      }
      <ng-container [ngTemplateOutlet]="skeletonRows" />
    </div>
  </div>
} @else {
  <div class="min-w-[900px]" data-testid="encounter-skeleton">
    <ng-container [ngTemplateOutlet]="skeletonRows" />
  </div>
}

<ng-template #skeletonRows>
  @for (row of placeholders; track row) {
    <div class="encounter-skeleton-row">
      @for (cell of skeletonCells; track $index) {
        <div class="encounter-skeleton-cell">
          <app-skeleton
            [width]="cell.width"
            [height]="cell.height"
            [rounded]="cell.rounded ?? 'md'"
          ></app-skeleton>
        </div>
      }
    </div>
  }
</ng-template>
